import { Component } from 'react';
import { toast } from 'react-toastify';
import DateTime from 'react-datetime';
import { Row, Col, Button, FormGroup } from 'react-bootstrap';
import fileDownload from 'react-file-download';
import { downloadCsvExport } from '../../../actions/non-ppc-mc-settings';
import ToastMessage from '../../common/toast-message';

class ExportDateForm extends Component {
  state = {
    fromDate: '',
    toDate: ''
  }

  onSubmit = () => {
    const { fromDate, toDate } = this.state;

    downloadCsvExport(fromDate, toDate)
      .then((response) => {
        this.downloadCsv(response.data);
      })
      .catch(() => {
        toast.error(<ToastMessage iconStyle="error" message="Cannot download export data" />);
      });
  }

  downloadCsv = (data) => {
    fileDownload(data, 'export.csv');
  }

  handleDateFromChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ fromDate: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ fromDate: '' });
    }
  };

  handleDateToChange = (value) => {
    if (typeof value === 'object') {
      this.setState({ toDate: value.format('DD/MM/YYYY') });
    } else {
      this.setState({ toDate: '' });
    }
  };

  render() {
    const { fromDate, toDate } = this.state;

    return (
      <div>
        <br />
        <Row>
          <Col md={6}>
            <FormGroup>
              From Date
              <DateTime
                timeFormat={false}
                dateFormat="DD/MM/YYYY"
                value={fromDate}
                onChange={this.handleDateFromChange}
                closeOnSelect
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              To Date
              <DateTime
                timeFormat={false}
                dateFormat="DD/MM/YYYY"
                value={toDate}
                onChange={this.handleDateToChange}
                closeOnSelect
              />
            </FormGroup>
          </Col>
        </Row>
        <Row className="mg-top-20">
          <Col className="text-right" md={12}>
            <Button className="red-ghost-btn" onClick={this.onSubmit}>
              Export Processed Invoice Redemptions
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ExportDateForm;
